import { render, staticRenderFns } from "./r-tile-table.vue?vue&type=template&id=ca8768ba"
import script from "./r-tile-table.vue?vue&type=script&lang=js"
export * from "./r-tile-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca8768ba')) {
      api.createRecord('ca8768ba', component.options)
    } else {
      api.reload('ca8768ba', component.options)
    }
    module.hot.accept("./r-tile-table.vue?vue&type=template&id=ca8768ba", function () {
      api.rerender('ca8768ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-tile-table.vue"
export default component.exports